import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api/api.service';
import { CalculatedVariable } from 'src/app/models/calculated-variable';

@Injectable({
  providedIn: 'root',
})
export class CalculatedVariablesService {
  getCalculatedVariablesForStudy(studyId: number): Observable<CalculatedVariable[]> {
    return this.apiService.get<CalculatedVariable[]>(`/dashboard/study/${studyId}/calculated_variables`);
  }

  createCalculatedVariable(
    calculatedVariable: CalculatedVariable & { study_id: number }
  ): Observable<CalculatedVariable> {
    const { study_id, ...payload } = calculatedVariable;

    return this.apiService.post<CalculatedVariable>(
      `/dashboard/study/${study_id}/calculated_variables`,
      payload
    );
  }

  updateCalculatedVariable(
    calculatedVariable: CalculatedVariable & { study_id: number }
  ): Observable<CalculatedVariable> {
    // Destructure study_id and id to remove them from the payload but keep them in URL
    const { study_id, id, ...payload } = calculatedVariable;

    return this.apiService.put<CalculatedVariable>(
      `/dashboard/study/${study_id}/calculated_variables/${id}`,
      payload
    );
  }

  deleteCalculatedVariable(calculatedVariable: CalculatedVariable & { study_id: number }): Observable<CalculatedVariable> {
    return this.apiService.delete<CalculatedVariable & { study_id: number }>(
      `/dashboard/study/${calculatedVariable.study_id}/calculated_variables/delete/${calculatedVariable.id}`
    );
  }

  getCalculatedVariablesForModule(studyId: number, moduleId: number): Observable<CalculatedVariable[]> {
    return this.apiService.get<CalculatedVariable[]>(`/dashboard/study/${studyId}/calculated_variables/${moduleId}`);
  }

  constructor(private apiService: ApiService) {}
}
